(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/detail-view-mobile-handler/assets/javascripts/detail-view-mobile-handler.js') >= 0) return;  svs.modules.push('/components/tipsen/detail-view-mobile-handler/assets/javascripts/detail-view-mobile-handler.js');
"use strict";

const {
  detect
} = svs.core;
const {
  useSelector
} = ReactRedux;
const {
  useCallback,
  useRef
} = React;
const {
  EventTypeField
} = svs.components.sportinfo.common.constants;
const {
  createEventStatisticsKey
} = svs.components.sportinfo.common.helpers;
const {
  getSportInfoMatchState
} = svs.components.sportinfo.common.matchState;
const {
  BigStatBanner
} = svs.components.sportInfo.bigStatBanner;
const {
  TipsenModal,
  StickyBottom,
  StickyButtonClose,
  StickyButtonIcon,
  ModalHeader
} = svs.components.tipsen.tipsenModal;
const {
  useQueryParam
} = svs.components.lbUtils;
const {
  useHistory,
  useLocation,
  Route,
  useRouteMatch
} = ReactRouterDOM;
const {
  selectSportEvent,
  selectEventStatisticCurrentValueByType,
  selectParticipants
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  useBranding,
  useGetParticipantName
} = svs.components.tipsen.hooks;
const {
  useCurrentDrawEvent,
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  LazyStatistic,
  LazyGameGuide,
  LazyOdds
} = svs.components.tipsen.sideNav;
const {
  TipsenModuleGameUrl
} = svs.components.sport.tipsenShared;
const useCloseModal = () => {
  const history = useHistory();
  const location = useLocation();
  const handleClose = () => {
    const search = new URLSearchParams(location.search);
    if (search.has('openStatistic')) {
      search.delete('openStatistic');
    }
    history.push({
      search: "?".concat(search)
    });
  };
  return handleClose;
};
const ModalFooter = _ref => {
  let {
    routesMatch
  } = _ref;
  return React.createElement(StickyBottom, null, React.createElement(StickyButtonClose, {
    to: {
      pathname: routesMatch.url
    }
  }));
};
const DetailsStickyBottom = _ref2 => {
  let {
    closeModal,
    onNavigateNext
  } = _ref2;
  return React.createElement(StickyBottom, {
    hasEvenplacement: false
  }, React.createElement(StickyButtonIcon, {
    icon: "menu-left",
    onClick: () => onNavigateNext(-1)
  }), React.createElement(StickyButtonClose, {
    isInverted: false,
    isTransparent: true,
    onClick: closeModal
  }), React.createElement(StickyButtonIcon, {
    icon: "menu-right",
    onClick: () => onNavigateNext(1)
  }));
};
const defaultSportEvent = {
  participants: [],
  leagueId: undefined,
  matchStart: undefined
};
const gameGuidePaths = ["/".concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.SINGLES, "/").concat(TipsenModuleGameUrl.GAME_GUIDE)];
const oddsPaths = ["/".concat(TipsenModuleGameUrl.ODDS)];
const DetailViewMobileHandler = _ref3 => {
  let {
    drawId,
    drawNumber,
    setCoupon,
    headerComponent,
    shouldIncludeExtraStats
  } = _ref3;
  const open = Boolean(useQueryParam('openStatistic') !== null);
  const [productBranding] = useBranding();
  const event = useCurrentDrawEvent(drawId);
  const matchId = event.matchId;
  const closeModal = useCloseModal();
  const routesMatch = useRouteMatch();
  const sportEvent = useSelector(state => selectSportEvent(state, matchId)) || defaultSportEvent;
  const participants = useSelector(state => selectParticipants(state, sportEvent.participants || []));
  const participantIds = participants.reduce((acc, curr) => {
    acc.push(curr.id);
    return acc;
  }, []);
  const odds = useSelector(state => selectEventStatisticCurrentValueByType(state, createEventStatisticsKey({
    matchId,
    eventTypeId: event.eventTypeId,
    participantIds
  }), EventTypeField.Odds));
  const league = useSelector(state => state.Leagues[sportEvent.leagueId]);
  const draw = useCurrentDraw(drawId);
  const [homeParticipant, awayParticipant] = useGetParticipantName(draw.productId, draw.drawNumber, event.eventNumber);
  const history = useHistory();
  const location = useLocation();
  const modalRef = useRef();
  const results = sportEvent === null || sportEvent === void 0 ? void 0 : sportEvent.result[0];
  const onNavigateNext = useCallback(next => {
    const maxMatchCount = draw.drawEvents.length;
    let nextEventNumber = event.eventNumber + next;
    if (nextEventNumber < 1) {
      nextEventNumber = maxMatchCount;
    } else if (nextEventNumber > maxMatchCount) {
      nextEventNumber = 1;
    }
    const search = new URLSearchParams(location.search);
    if (search.has('openStatistic')) {
      search.set('event', nextEventNumber);
    }
    history.replace({
      search: "?".concat(search)
    });
    modalRef.current.scrollTo(0, 0);
  }, [event.eventNumber, location.search, history, draw.drawEvents.length]);
  const matchState = getSportInfoMatchState(sportEvent.sportEventStatus);
  return React.createElement(React.Fragment, null, React.createElement(TipsenModal, {
    Bottom: () => React.createElement(DetailsStickyBottom, {
      closeModal: closeModal,
      onNavigateNext: onNavigateNext
    }),
    isOpen: open,
    ref: modalRef
  }, React.createElement(BigStatBanner, {
    awayTeam: awayParticipant,
    className: "pg_detail_header pg_detail_header--".concat(productBranding),
    eventNumber: event.eventNumber,
    homeTeam: homeParticipant,
    leagueName: league === null || league === void 0 ? void 0 : league.name,
    matchId: matchId,
    matchState: matchState,
    odds: {
      one: odds[0],
      x: odds[1],
      two: odds[2]
    },
    productId: draw.productId,
    results: results,
    sportType: league === null || league === void 0 ? void 0 : league.sportType,
    startTime: sportEvent.matchStart,
    statusCode: sportEvent.sportEventStatus
  }), detect.feature('ft-tipsen2-statistics-bet') && headerComponent && React.createElement("div", {
    className: "pg_detail_view__bet-buttons pg_detail_view__bet-buttons--".concat(productBranding)
  }, headerComponent), React.createElement(LazyStatistic, {
    branding: productBranding,
    drawNumber: drawNumber,
    matchId: matchId,
    productId: draw.productId,
    setCoupon: setCoupon
    ,
    shouldIncludeExtraStats: shouldIncludeExtraStats
  })), React.createElement(Route, {
    path: gameGuidePaths,
    render: _ref4 => {
      let {
        match
      } = _ref4;
      return React.createElement(TipsenModal, {
        Bottom: () => React.createElement(ModalFooter, {
          routesMatch: routesMatch
        }),
        isOpen: Boolean(match)
      }, React.createElement(ModalHeader, null, "Spelguide"), React.createElement(LazyGameGuide, {
        branding: productBranding,
        className: "padding-left-2 padding-right-2",
        matchId: matchId
      }));
    }
  }), React.createElement(Route, {
    path: oddsPaths,
    render: _ref5 => {
      let {
        match
      } = _ref5;
      return React.createElement(TipsenModal, {
        Bottom: () => React.createElement(ModalFooter, {
          routesMatch: routesMatch
        }),
        isOpen: Boolean(match)
      }, React.createElement(LazyOdds, {
        branding: productBranding
      }));
    }
  }));
};
setGlobal('svs.components.tipsen.detailViewMobileHandler.DetailViewMobileHandler', DetailViewMobileHandler);

 })(window);